<template>
    <div
        v-if="visible"
        class="alert-banner alert-warning show mb-0 sticky-alert"
        role="alert"
    >
        <button type="button" class="close" @click="dismiss" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
        <h6 class="mb-0"><i :class="icon"></i> <b v-if="heading">{{ heading }}</b> {{ message }}</h6>
    </div>
</template>

<script>
export default {
    name: 'AlertBannerComponent',
    props: {
        show: {
            type: [Boolean, String],
            default: false
        }
    },
    data() {
        return {
            visible: false,
            heading: '',
            icon: 'fas fa-exclamation-triangle',
            message: '',
            cacheKey: null
        }
    },
    mounted() {
        fetch('/api/alert-message')
            .then(res => res.json())
            .then(data => {
                this.heading = data.heading;
                this.icon = data.icon;
                this.message = data.message;

                if (this.message && this.message !== '') {
                    this.cacheKey = `alert-dismissed-${this.generateHash(this.message)}`;

                    const isDismissed = localStorage.getItem(this.cacheKey) === 'true';

                    this.visible = !isDismissed && (typeof this.show === 'string' ? this.show === 'true' : this.show);
                }
            })
            .catch(err => {
                console.error('Error fetching alert message:', err);
                this.message = 'Error loading message';
            });
    },
    watch: {
        show(newVal) {
            this.visible = typeof newVal === 'string' ? newVal === 'true' : newVal;
        }
    },
    methods: {
        dismiss() {
            this.visible = false;

            if (this.cacheKey) {
                localStorage.setItem(this.cacheKey, 'true');
            }
        },
        generateHash(str) {
            let hash = 0;
            if (!str || str.length === 0) return hash;

            for (let i = 0; i < str.length; i++) {
                const char = str.charCodeAt(i);
                hash = ((hash << 5) - hash) + char;
                hash = hash & hash;
            }
            return Math.abs(hash).toString(16);
        }
    }
};
</script>

<style scoped>
.sticky-alert {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1100;
    color: #0a0a0a;
}
</style>
